/*
  Aimance : comportements sur mesure du thème Dawn.
  Règle : tout ici est facultatif. Si ce script échoue ou ne se charge pas, les fonctions natives
  (variantes, ajout au panier, panier en tiroir, paiement express) continuent de marcher :
  - l'option écrin et la barre collante restent masquées (attribut hidden) ;
  - l'encadré urgence garde son texte calculé en Liquid ;
  - « Choisir un modèle » (offre 2e collier) reste un lien vers la fiche produit.
*/
(function () {
  'use strict';

  var NBSP = ' ';
  var MOIS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  var FERIES = ['01-01', '05-01', '05-08', '07-14', '08-15', '11-01', '11-11', '12-25'];

  /* ------------------------------------------------------------------ Outils */

  function devise() {
    try {
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    } catch (e) {
      return 'EUR';
    }
  }

  // Même rendu que le filtre Liquid « money » : on applique le format monétaire de la boutique
  // (Paramètres > Infos boutique > Devise), exposé par snippets/aimance-head.liquid.
  function avecSeparateurs(centimes, decimales, milliers, decimal) {
    var fixe = (Number(centimes) / 100).toFixed(decimales);
    var parties = fixe.split('.');
    var entier = parties[0].replace(/\B(?=(\d{3})+(?!\d))/g, milliers);
    return parties[1] ? entier + decimal + parties[1] : entier;
  }

  function prixFormatBoutique(centimes) {
    var format = window.aimanceFormatPrix;
    if (typeof format !== 'string') return null;
    var balise = /\{\{\s*(\w+)\s*\}\}/.exec(format);
    if (!balise) return null;
    var montant;
    switch (balise[1]) {
      case 'amount':
        montant = avecSeparateurs(centimes, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        montant = avecSeparateurs(centimes, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        montant = avecSeparateurs(centimes, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        montant = avecSeparateurs(centimes, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        montant = avecSeparateurs(centimes, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        montant = avecSeparateurs(centimes, 0, ' ', ',');
        break;
      case 'amount_with_apostrophe_separator':
        montant = avecSeparateurs(centimes, 2, "'", '.');
        break;
      default:
        return null;
    }
    var html = format.replace(balise[0], montant);
    // DOMParser : document inerte (aucun script ni chargement), seulement pour retirer d'éventuelles balises.
    var texte = new DOMParser().parseFromString(html, 'text/html').body.textContent || '';
    return texte.trim() || null;
  }

  function prix(centimes) {
    try {
      var formate = prixFormatBoutique(centimes);
      if (formate) return formate;
    } catch (e) {
      /* repli ci-dessous */
    }
    var montant = Number(centimes) / 100;
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: devise() })
        .format(montant)
        .replace(/ /g, NBSP);
    } catch (e) {
      return montant.toFixed(2).replace('.', ',') + NBSP + '€';
    }
  }

  // Événements standard de Shopify (window.StandardEvents, chargés par layout/theme.liquid),
  // émis comme le fait product-form.js de Dawn, pour les applis et la mesure d'audience.
  function evenementLignes(cible, contexte, lignes) {
    var SE = window.StandardEvents || {};
    if (!SE.CartLinesUpdateEvent || !cible) return null;
    try {
      var differe = SE.CartLinesUpdateEvent.createPromise();
      cible.dispatchEvent(
        new SE.CartLinesUpdateEvent({ action: 'add', context: contexte, lines: lignes, promise: differe.promise })
      );
      return differe;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  function resoudreLignes(differe) {
    var SE = window.StandardEvents || {};
    if (!differe || !SE.CartLinesUpdateEvent) return;
    fetch(urlPanier() + '.json')
      .then(function (reponse) {
        return reponse.json();
      })
      .then(function (panier) {
        if (!panier || !panier.currency) return differe.reject(new Error('Missing currency in cart response'));
        differe.resolve({ cart: SE.CartLinesUpdateEvent.createCartFromAjaxResponse(panier) });
      })
      .catch(function (e) {
        differe.reject(e);
      });
  }

  function erreurPanier(cible, differe, message, code) {
    var SE = window.StandardEvents || {};
    if (differe) differe.reject(new Error(message));
    if (!SE.CartErrorEvent || !cible) return;
    try {
      cible.dispatchEvent(new SE.CartErrorEvent({ error: message, code: code }));
    } catch (e) {
      console.error(e);
    }
  }

  function pubSubPret() {
    return typeof subscribe === 'function' && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  }

  // Abonnement unique au changement de variante natif (publié par product-info.js).
  var gestionnairesVariante = [];
  var abonneVariante = false;
  function surChangementVariante(fn) {
    gestionnairesVariante.push(fn);
    if (abonneVariante || !pubSubPret()) return;
    abonneVariante = true;
    subscribe(PUB_SUB_EVENTS.variantChange, function (evenement) {
      var donnees = evenement && evenement.data;
      if (!donnees || !donnees.variant) return;
      gestionnairesVariante.forEach(function (gestionnaire) {
        try {
          gestionnaire(donnees.variant, donnees.sectionId);
        } catch (e) {
          console.error(e);
        }
      });
    });
  }

  function publierPanier(source, reponse, variantId) {
    if (!pubSubPret()) return;
    try {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: source, productVariantId: variantId, cartData: reponse });
    } catch (e) {
      console.error(e);
    }
  }

  function configPost(corps) {
    var config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(corps);
    return config;
  }

  function urlAjout() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  function urlPanier() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function tiroir() {
    var el = document.querySelector('cart-drawer');
    return el && typeof el.renderContents === 'function' && typeof el.getSectionsToRender === 'function' ? el : null;
  }

  function prixVarianteSelectionnee(info, repli) {
    try {
      var json = info && info.querySelector('variant-selects [data-selected-variant]');
      var variante = json && JSON.parse(json.textContent);
      if (variante && variante.price != null) return Number(variante.price);
    } catch (e) {
      /* repli ci-dessous */
    }
    var nombre = parseInt(repli, 10);
    return isNaN(nombre) ? null : nombre;
  }

  /* --------------------------------------------- Légendes « Silhouette : Femme » */

  function legendes(racine) {
    (racine || document).querySelectorAll('variant-selects fieldset.product-form__input--pill').forEach(function (champ) {
      var legende = champ.querySelector('legend');
      if (!legende) return;
      var coche = champ.querySelector('input[type="radio"]:checked');
      var valeur = legende.querySelector('.aimance-legende-valeur');
      if (!valeur) {
        valeur = document.createElement('span');
        valeur.className = 'aimance-legende-valeur';
        legende.appendChild(valeur);
      }
      var texteValeur = coche ? coche.value : '';
      if (valeur.textContent !== texteValeur) valeur.textContent = texteValeur;
    });

    // Pastilles image (si l'option Couleur en a dans l'admin) : « Couleur: » natif devient « Couleur : ».
    (racine || document).querySelectorAll('variant-selects fieldset.product-form__input--swatch legend').forEach(function (legende) {
      var valeur = legende.querySelector('[data-selected-value]');
      if (!valeur || valeur.classList.contains('aimance-legende-valeur')) return;
      Array.prototype.forEach.call(legende.childNodes, function (noeud) {
        if (noeud.nodeType !== 3) return;
        var nettoye = noeud.textContent.replace(/\s*:\s*$/, '');
        if (nettoye !== noeud.textContent) noeud.textContent = nettoye;
      });
      valeur.classList.add('aimance-legende-valeur');
    });
  }

  // Le sélecteur natif est remplacé à chaque choix (y compris pour une combinaison qui n'existe pas,
  // sans événement variantChange) : on repose les légendes après chaque remplacement.
  function surveillerLegendes() {
    if (!('MutationObserver' in window)) return;
    document.querySelectorAll('product-info').forEach(function (info) {
      if (info.dataset.aimanceLegendes) return;
      info.dataset.aimanceLegendes = '1';
      var prevu = false;
      new MutationObserver(function () {
        if (prevu) return;
        prevu = true;
        requestAnimationFrame(function () {
          prevu = false;
          legendes(info);
        });
      }).observe(info, { childList: true, subtree: true });
    });
  }

  /* ------------------------------------- Premier onglet de la fiche ouvert */

  function premierOnglet() {
    var details = document.querySelector('product-info[id^="MainProduct-"] .product__accordion details');
    if (details && !details.dataset.aimanceOuvert) {
      details.dataset.aimanceOuvert = '1';
      details.open = true;
    }
  }

  /* ------------------------------------------------------------------ Klarna */

  // Mensualité = prix / nombre de fois, arrondie au centime supérieur (même calcul que snippets/aimance-klarna.liquid).
  function majKlarna(racine, variante) {
    racine.querySelectorAll('[data-aimance-klarna]').forEach(function (ligne) {
      var montant = ligne.querySelector('[data-aimance-klarna-montant]');
      var fois = Math.max(2, parseInt(ligne.dataset.nombre, 10) || 3);
      if (montant) montant.textContent = prix(Math.ceil(Number(variante.price) / fois));
    });
  }

  /* ------------------------------------------------------- Encadré urgence */

  function deux(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function partiesParis(date) {
    var format = new Intl.DateTimeFormat('fr-FR', {
      timeZone: 'Europe/Paris',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      hourCycle: 'h23',
    });
    var parties = {};
    format.formatToParts(date).forEach(function (partie) {
      parties[partie.type] = partie.value;
    });
    return {
      an: parseInt(parties.year, 10),
      mois: parseInt(parties.month, 10),
      jour: parseInt(parties.day, 10),
      heure: parseInt(parties.hour, 10) % 24,
    };
  }

  function ajouterJoursOuvres(base, nombre, feries) {
    var date = new Date(base.getTime());
    var garde = 0;
    while (nombre > 0 && garde < 400) {
      garde++;
      date.setUTCDate(date.getUTCDate() + 1);
      var jourSemaine = date.getUTCDay();
      var cle = deux(date.getUTCMonth() + 1) + '-' + deux(date.getUTCDate());
      if (jourSemaine !== 0 && jourSemaine !== 6 && feries.indexOf(cle) === -1) nombre--;
    }
    return date;
  }

  function jourDuMois(date) {
    var jour = date.getUTCDate();
    return jour === 1 ? '1er' : String(jour);
  }

  // Réglages du bloc « Délai et urgence » (attributs data-* posés par snippets/aimance-urgence.liquid).
  function reglagesUrgence(bloc) {
    var d = bloc.dataset;
    var min = parseInt(d.min, 10);
    var max = parseInt(d.max, 10);
    min = isNaN(min) ? 5 : min;
    max = isNaN(max) ? 7 : Math.max(max, min);
    var feries = d.feries == null ? FERIES : d.feries.replace(/\s/g, '').split(',').filter(Boolean);
    return {
      mode: d.mode === 'fixe' ? 'fixe' : 'suivante',
      heureFixe: parseInt(d.heureFixe, 10) || 15,
      demain: d.demain || '',
      minuit: d.minuit || 'minuit',
      min: min,
      max: max,
      feries: feries,
      texteDates: d.texteDates || 'entre le [debut] et le [fin]',
      texteDateUnique: d.texteDateUnique || 'le [fin]',
      point: d.point === 'true',
    };
  }

  function calculUrgence(maintenant, r) {
    r = r || reglagesUrgence(document.createElement('div'));
    var paris = partiesParis(maintenant);
    var aujourdhui = new Date(Date.UTC(paris.an, paris.mois - 1, paris.jour, 12));
    var heure;
    if (r.mode === 'fixe') {
      heure = r.heureFixe + NBSP + 'h';
      if (paris.heure >= r.heureFixe) {
        aujourdhui.setUTCDate(aujourdhui.getUTCDate() + 1);
        if (r.demain) heure = r.demain + ' ' + heure;
      }
    } else {
      var suivante = (paris.heure + 1) % 24;
      heure = suivante === 0 ? r.minuit : suivante + NBSP + 'h';
    }
    var debut = ajouterJoursOuvres(aujourdhui, r.min, r.feries);
    var fin = ajouterJoursOuvres(aujourdhui, r.max, r.feries);
    var texteFin = jourDuMois(fin) + ' ' + MOIS[fin.getUTCMonth()];
    var plage;
    if (r.min === r.max) {
      plage = r.texteDateUnique.split('[fin]').join(texteFin);
    } else {
      var texteDebut =
        debut.getUTCMonth() === fin.getUTCMonth() ? jourDuMois(debut) : jourDuMois(debut) + ' ' + MOIS[debut.getUTCMonth()];
      plage = r.texteDates.split('[debut]').join(texteDebut).split('[fin]').join(texteFin);
    }
    if (r.point && plage.slice(-1) !== '.') plage += '.';
    return { heure: heure, plage: plage };
  }

  function initUrgence(bloc) {
    if (bloc.dataset.aimancePret) return;
    bloc.dataset.aimancePret = '1';

    var heure = bloc.querySelector('[data-aimance-heure]');
    var plage = bloc.querySelector('[data-aimance-plage]');
    var stock = bloc.querySelector('[data-aimance-stock]');
    var idsStockFaible = (bloc.dataset.stockFaible || '').split(',').filter(Boolean);
    var info = bloc.closest('product-info');
    var reglages = reglagesUrgence(bloc);

    function maj() {
      if (!document.contains(bloc)) return;
      var calcul = calculUrgence(new Date(), reglages);
      if (heure) heure.textContent = calcul.heure;
      if (plage) plage.textContent = calcul.plage;
    }
    maj();
    var minuteur = setInterval(function () {
      if (!document.contains(bloc)) return clearInterval(minuteur);
      maj();
    }, 60000);

    surChangementVariante(function (variante, sectionId) {
      if (!stock || !info || sectionId !== info.dataset.section) return;
      stock.hidden = idsStockFaible.indexOf(String(variante.id)) === -1;
    });
  }

  /* ------------------------------------------------------------ Option écrin */

  function initEcrin(bloc) {
    if (bloc.dataset.aimancePret) return;

    var info = bloc.closest('product-info');
    var productForm = info && info.querySelector('product-form');
    var formulaire = productForm && productForm.querySelector('form');
    var caseEcrin = bloc.querySelector('[data-aimance-ecrin-case]');
    var zone = bloc.querySelector('[data-aimance-ecrin-zone]');
    var texte = bloc.querySelector('[data-aimance-ecrin-texte]');
    var compte = bloc.querySelector('[data-aimance-ecrin-compte]');
    var erreur = bloc.querySelector('[data-aimance-ecrin-erreur]');
    var ecrinId = parseInt(bloc.dataset.variantId, 10);
    var ecrinPrix = parseInt(bloc.dataset.price, 10) || 0;
    var maximum = parseInt(bloc.dataset.max, 10) || 150;
    var obligatoire = bloc.dataset.obligatoire !== 'false';
    if (!formulaire || !caseEcrin || !zone || !texte || !ecrinId) return;

    bloc.dataset.aimancePret = '1';
    var prixVariante = prixVarianteSelectionnee(info, bloc.dataset.prixVariante);

    function bouton() {
      return productForm.querySelector('[type="submit"][name="add"]');
    }

    function libelleBouton() {
      var b = bouton();
      var span = b && b.querySelector('span');
      if (!span || b.hasAttribute('disabled')) return;
      var base = (window.variantStrings && window.variantStrings.addToCart) || span.textContent.split(' · ')[0];
      span.textContent = caseEcrin.checked && prixVariante != null ? base + ' · ' + prix(prixVariante + ecrinPrix) : base;
    }

    function annoncerTotal() {
      document.dispatchEvent(
        new CustomEvent('aimance:total', {
          detail: {
            section: info.dataset.section,
            total: prixVariante == null ? null : prixVariante + (caseEcrin.checked ? ecrinPrix : 0),
          },
        })
      );
    }

    function masquerErreur() {
      texte.removeAttribute('aria-invalid');
      if (erreur) {
        erreur.hidden = true;
        erreur.textContent = '';
      }
    }

    function afficherErreur() {
      texte.setAttribute('aria-invalid', 'true');
      if (erreur) {
        erreur.textContent = erreur.dataset.message || '';
        erreur.hidden = false;
      }
      texte.focus();
    }

    function maj() {
      zone.hidden = !caseEcrin.checked;
      bloc.classList.toggle('aimance-ecrin--actif', caseEcrin.checked);
      info.classList.toggle('aimance-ecrin-actif', caseEcrin.checked);
      if (!caseEcrin.checked) masquerErreur();
      libelleBouton();
      annoncerTotal();
    }

    caseEcrin.addEventListener('change', maj);
    texte.addEventListener('input', function () {
      if (compte) compte.textContent = String(texte.value.length);
      if (texte.value.trim()) masquerErreur();
    });

    surChangementVariante(function (variante, sectionId) {
      if (sectionId !== info.dataset.section) return;
      prixVariante = Number(variante.price);
      libelleBouton();
      annoncerTotal();
    });

    function ajouterAvecEcrin(donnees, variantId) {
      var b = bouton();
      var panier = tiroir();
      var spinner = productForm.querySelector('.loading__spinner');
      var quantite = parseInt(donnees.get('quantity'), 10) || 1;
      var proprietes = {};
      donnees.forEach(function (valeur, cle) {
        var correspondance = /^properties\[(.+)\]$/.exec(cle);
        if (correspondance && typeof valeur === 'string' && valeur !== '') proprietes[correspondance[1]] = valeur;
      });
      proprietes['Écrin'] = 'Oui';
      var message = (texte.value || '').trim().slice(0, maximum);

      // Le panier affiche en premier le dernier article ajouté : l'écrin passe d'abord pour que le collier reste en haut.
      var corps = {
        items: [
          message ? { id: ecrinId, quantity: 1, properties: { Message: message } } : { id: ecrinId, quantity: 1 },
          { id: variantId, quantity: quantite, properties: proprietes },
        ],
      };
      if (panier) {
        corps.sections = panier.getSectionsToRender().map(function (section) {
          return section.id;
        });
        corps.sections_url = window.location.pathname;
        if (typeof panier.setActiveElement === 'function') panier.setActiveElement(document.activeElement);
      }

      if (typeof productForm.handleErrorMessage === 'function') productForm.handleErrorMessage();
      if (b) {
        b.setAttribute('aria-disabled', 'true');
        b.classList.add('loading');
      }
      if (spinner) spinner.classList.remove('hidden');

      var differe = evenementLignes(productForm, 'product', [
        { merchandiseId: String(variantId), quantity: quantite },
        { merchandiseId: String(ecrinId), quantity: 1 },
      ]);

      fetch(urlAjout(), configPost(corps))
        .then(function (reponse) {
          return reponse.json();
        })
        .then(function (reponse) {
          if (reponse.status) {
            var texteErreur = reponse.description || reponse.message || '';
            if (pubSubPret()) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: reponse.errors || reponse.description,
                message: reponse.message,
              });
            }
            if (typeof productForm.handleErrorMessage === 'function') productForm.handleErrorMessage(texteErreur);
            erreurPanier(productForm, differe, texteErreur, 'INVALID');
            return;
          }
          resoudreLignes(differe);
          if (!panier) {
            window.location = urlPanier();
            return;
          }
          publierPanier('product-form', reponse, variantId);
          panier.renderContents(reponse);
        })
        .catch(function (e) {
          console.error(e);
          erreurPanier(productForm, differe, (e && e.message) || 'Network error', 'SERVICE_UNAVAILABLE');
          if (typeof productForm.handleErrorMessage === 'function') {
            productForm.handleErrorMessage((window.cartStrings && window.cartStrings.error) || 'Erreur');
          }
        })
        .finally(function () {
          if (b) {
            b.classList.remove('loading');
            b.removeAttribute('aria-disabled');
          }
          if (spinner) spinner.classList.add('hidden');
          if (panier && panier.classList.contains('is-empty')) panier.classList.remove('is-empty');
        });
    }

    // Écoute en capture : passe avant le gestionnaire natif de product-form, seulement si l'écrin est coché.
    // Écrin coché sans message : l'ajout est bloqué et le champ signalé (la carte promet un texte imprimé).
    document.addEventListener(
      'submit',
      function (evenement) {
        if (evenement.target !== formulaire || !caseEcrin.checked || !document.contains(bloc)) return;
        var b = bouton();
        if (b && b.getAttribute('aria-disabled') === 'true') return;
        var donnees = new FormData(formulaire);
        var variantId = parseInt(donnees.get('id'), 10);
        if (!variantId) return;
        evenement.preventDefault();
        evenement.stopImmediatePropagation();
        if (obligatoire && !texte.value.trim()) {
          afficherErreur();
          return;
        }
        ajouterAvecEcrin(donnees, variantId);
      },
      true
    );

    bloc.hidden = false;
    maj();
  }

  /* ------------------------------------------------- Barre d'achat collante */

  function initBarre(barre) {
    if (barre.dataset.aimancePret) return;

    var info = document.querySelector('product-info[id^="MainProduct-"]');
    var bouton = barre.querySelector('[data-aimance-barre-bouton]');
    var cible = info && (info.querySelector('.product-form__buttons') || info.querySelector('product-form'));
    if (!info || !bouton || !cible || !('IntersectionObserver' in window)) return;

    barre.dataset.aimancePret = '1';
    var productForm = info.querySelector('product-form');
    var libelle = barre.querySelector('[data-aimance-barre-variante]');
    var prixEl = barre.querySelector('[data-aimance-barre-prix]');
    var image = barre.querySelector('.aimance-barre__image');
    var libelleAjout = bouton.textContent.trim();
    var depuisBarre = 0;

    function boutonNatif() {
      return info.querySelector('product-form [type="submit"][name="add"]');
    }

    // Visible tant que le bouton d'achat principal n'est pas à l'écran (au-dessus comme en dessous),
    // donc dès l'arrivée sur la fiche quand le bouton est sous la ligne de flottaison.
    var observateur = new IntersectionObserver(function (entrees) {
      var entree = entrees[entrees.length - 1];
      barre.classList.toggle('aimance-barre--visible', !entree.isIntersecting);
    });
    observateur.observe(cible);

    // Recopie l'état du bouton natif (épuisé, indisponible) dans la barre.
    function synchroniser() {
      var natif = boutonNatif();
      if (!natif) return;
      var inactif = natif.hasAttribute('disabled');
      var span = natif.querySelector('span');
      bouton.disabled = inactif;
      bouton.textContent = inactif && span ? span.textContent.split(' · ')[0].trim() : libelleAjout;
    }

    // Erreur native (rupture, quantité…) après un clic dans la barre : on ramène le formulaire à l'écran.
    function erreurVisible() {
      var enveloppe = info.querySelector('.product-form__error-message-wrapper');
      if (!enveloppe || enveloppe.hasAttribute('hidden') || Date.now() - depuisBarre > 8000) return;
      depuisBarre = 0;
      enveloppe.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    if (productForm && 'MutationObserver' in window) {
      new MutationObserver(function () {
        synchroniser();
        erreurVisible();
      }).observe(productForm, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'hidden'] });
    }
    synchroniser();

    bouton.addEventListener('click', function () {
      var natif = boutonNatif();
      if (!natif || natif.hasAttribute('disabled')) return;
      depuisBarre = Date.now();
      natif.click();
    });

    function totalAffiche(prixVariante) {
      var ecrin = info.querySelector('[data-aimance-ecrin]');
      var supplement = ecrin && info.classList.contains('aimance-ecrin-actif') ? parseInt(ecrin.dataset.price, 10) || 0 : 0;
      return Number(prixVariante) + supplement;
    }

    surChangementVariante(function (variante, sectionId) {
      if (sectionId !== info.dataset.section) return;
      if (libelle && variante.options && variante.options.length) libelle.textContent = variante.options.join(' · ');
      if (prixEl) prixEl.textContent = prix(totalAffiche(variante.price));
      var source = variante.featured_image && variante.featured_image.src;
      if (image && source) {
        image.removeAttribute('srcset');
        image.src = source + (source.indexOf('?') === -1 ? '?' : '&') + 'width=132';
      }
      synchroniser();
    });

    document.addEventListener('aimance:total', function (evenement) {
      var detail = evenement.detail || {};
      if (detail.section === info.dataset.section && detail.total != null && prixEl) prixEl.textContent = prix(detail.total);
    });

    barre.hidden = false;
    document.body.classList.add('aimance-barre-presente');
    if (barre.hasAttribute('data-ordinateur')) document.body.classList.add('aimance-barre-presente--ordinateur');
  }

  /* --------------------------------------- Offre 2e collier (panier en tiroir) */

  function etatOffre(offre) {
    if (offre.aimanceEtat) return offre.aimanceEtat;
    var variantes = [];
    try {
      variantes = JSON.parse(offre.querySelector('[data-aimance-offre-variantes]').textContent) || [];
    } catch (e) {
      variantes = [];
    }
    var premiere =
      variantes.find(function (v) {
        return v.available;
      }) || variantes[0];
    offre.aimanceEtat = { variantes: variantes, choix: premiere ? premiere.options.slice() : [] };
    return offre.aimanceEtat;
  }

  function varianteChoisie(etat) {
    return etat.variantes.find(function (v) {
      return (
        v.available &&
        v.options.every(function (valeur, i) {
          return valeur === etat.choix[i];
        })
      );
    });
  }

  function rendreOffre(offre) {
    var etat = etatOffre(offre);
    offre.querySelectorAll('[data-aimance-offre-option]').forEach(function (groupe) {
      var index = parseInt(groupe.dataset.aimanceOffreOption, 10);
      groupe.querySelectorAll('[data-aimance-offre-valeur]').forEach(function (b) {
        var valeur = b.dataset.aimanceOffreValeur;
        var possible = etat.variantes.some(function (v) {
          if (!v.available || v.options[index] !== valeur) return false;
          for (var k = 0; k < index; k++) {
            if (v.options[k] !== etat.choix[k]) return false;
          }
          return true;
        });
        b.disabled = !possible;
        b.hidden = !possible;
        b.setAttribute('aria-pressed', etat.choix[index] === valeur ? 'true' : 'false');
      });
    });
  }

  function choisirOffre(offre, index, valeur) {
    var etat = etatOffre(offre);
    etat.choix[index] = valeur;
    if (!varianteChoisie(etat)) {
      var proche = etat.variantes.find(function (v) {
        if (!v.available) return false;
        for (var k = 0; k <= index; k++) {
          if (v.options[k] !== etat.choix[k]) return false;
        }
        return true;
      });
      if (proche) etat.choix = proche.options.slice();
    }
    var erreur = offre.querySelector('[data-aimance-offre-erreur]');
    if (erreur) erreur.hidden = true;
    rendreOffre(offre);
  }

  function ajouterOffre(offre, bouton) {
    var etat = etatOffre(offre);
    var variante = varianteChoisie(etat);
    var erreur = offre.querySelector('[data-aimance-offre-erreur]');
    function afficherErreur(message) {
      if (!erreur) return;
      erreur.textContent = message;
      erreur.hidden = false;
    }
    if (!variante) {
      afficherErreur((window.variantStrings && window.variantStrings.unavailable) || 'Indisponible');
      return;
    }

    var panier = tiroir();
    var corps = { id: variante.id, quantity: 1 };
    if (panier) {
      corps.sections = panier.getSectionsToRender().map(function (section) {
        return section.id;
      });
      corps.sections_url = window.location.pathname;
    }
    bouton.disabled = true;
    bouton.setAttribute('aria-busy', 'true');
    var emetteur = panier || offre;
    var differe = evenementLignes(emetteur, 'cart', [{ merchandiseId: String(variante.id), quantity: 1 }]);

    fetch(urlAjout(), configPost(corps))
      .then(function (reponse) {
        return reponse.json();
      })
      .then(function (reponse) {
        if (reponse.status) {
          var texteErreur = reponse.description || reponse.message || '';
          afficherErreur(texteErreur);
          erreurPanier(emetteur, differe, texteErreur, 'INVALID');
          return;
        }
        resoudreLignes(differe);
        if (!panier) {
          window.location = urlPanier();
          return;
        }
        panier.renderContents(reponse);
        publierPanier('aimance-offre', reponse, variante.id);
      })
      .catch(function (e) {
        console.error(e);
        erreurPanier(emetteur, differe, (e && e.message) || 'Network error', 'SERVICE_UNAVAILABLE');
        afficherErreur((window.cartStrings && window.cartStrings.error) || 'Erreur');
      })
      .finally(function () {
        if (document.contains(bouton)) {
          bouton.disabled = false;
          bouton.removeAttribute('aria-busy');
        }
      });
  }

  document.addEventListener('click', function (evenement) {
    var cible = evenement.target;
    if (!(cible instanceof Element)) return;

    var ouvrir = cible.closest('[data-aimance-offre-ouvrir]');
    if (ouvrir) {
      var offre = ouvrir.closest('[data-aimance-offre]');
      var choix = offre && offre.querySelector('[data-aimance-offre-choix]');
      if (!choix) return;
      evenement.preventDefault();
      rendreOffre(offre);
      choix.hidden = false;
      ouvrir.hidden = true;
      var premier = choix.querySelector('[aria-pressed="true"]') || choix.querySelector('button:not([disabled])');
      if (premier) premier.focus();
      return;
    }

    var valeur = cible.closest('[data-aimance-offre-valeur]');
    if (valeur) {
      var groupe = valeur.closest('[data-aimance-offre-option]');
      choisirOffre(valeur.closest('[data-aimance-offre]'), parseInt(groupe.dataset.aimanceOffreOption, 10), valeur.dataset.aimanceOffreValeur);
      return;
    }

    var ajouter = cible.closest('[data-aimance-offre-ajouter]');
    if (ajouter) ajouterOffre(ajouter.closest('[data-aimance-offre]'), ajouter);
  });

  /* ------------------------------------------------------------ Démarrage */

  function essayer(fn, arg) {
    try {
      fn(arg);
    } catch (e) {
      console.error(e);
    }
  }

  function init() {
    document.querySelectorAll('[data-aimance-ecrin]').forEach(function (el) {
      essayer(initEcrin, el);
    });
    document.querySelectorAll('[data-aimance-urgence]').forEach(function (el) {
      essayer(initUrgence, el);
    });
    document.querySelectorAll('[data-aimance-barre]').forEach(function (el) {
      essayer(initBarre, el);
    });
    essayer(legendes, document);
    essayer(surveillerLegendes);
    essayer(premierOnglet);
  }

  surChangementVariante(function (variante, sectionId) {
    var racine = document.querySelector('product-info[data-section="' + sectionId + '"]') || document;
    majKlarna(racine, variante);
    legendes(racine);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  /* ------------------------------ Choix d'une option qui n'existe pas avec les autres (ex. Chat + Bicolore noir) :
     on bascule les autres options sur la combinaison existante la plus proche, AVANT que Dawn ne lise la sélection
     (écouteur en phase de capture). Sans script ou sans données, le comportement natif de Dawn reste. */

  var aimanceVariantes = {};

  function chargerVariantes(selects) {
    var handle = selects.dataset.productHandle;
    if (!handle || aimanceVariantes[handle]) return;
    aimanceVariantes[handle] = [];
    var racine = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(racine + 'products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (p) {
        if (p && p.variants) aimanceVariantes[handle] = p.variants;
      })
      .catch(function () {});
  }

  function initCombinaisons() {
    document.querySelectorAll('variant-selects[data-product-handle]').forEach(chargerVariantes);
  }

  initCombinaisons();
  document.addEventListener('shopify:section:load', initCombinaisons);

  document.addEventListener(
    'change',
    function (e) {
      var input = e.target;
      if (!input || input.type !== 'radio' || !input.closest) return;
      var selects = input.closest('variant-selects');
      var variantes = selects && aimanceVariantes[selects.dataset.productHandle];
      if (!variantes || !variantes.length) return;

      var groupes = Array.prototype.slice.call(selects.querySelectorAll('fieldset'));
      var index = groupes.indexOf(input.closest('fieldset'));
      if (index < 0) return;
      var choix = groupes.map(function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
      var existe = variantes.some(function (v) {
        return v.options.every(function (o, i) {
          return o === choix[i];
        });
      });
      if (existe) return;

      var meilleure = null;
      var meilleurScore = -1;
      variantes.forEach(function (v) {
        if (v.options[index] !== choix[index]) return;
        var score = v.available ? 100 : 0;
        v.options.forEach(function (o, i) {
          if (i !== index && o === choix[i]) score += 10 - i;
        });
        if (score > meilleurScore) {
          meilleurScore = score;
          meilleure = v;
        }
      });
      if (!meilleure) return;

      groupes.forEach(function (g, i) {
        if (i === index || meilleure.options[i] === choix[i]) return;
        g.querySelectorAll('input[type="radio"]').forEach(function (r) {
          if (r.value === meilleure.options[i]) r.checked = true;
        });
      });
    },
    true
  );

  /* ------------------------------ Section « Avis clients » : flèches, points, défilement au doigt (natif) */

  function initAvis(racine) {
    var piste = racine.querySelector('[data-aimance-avis-piste]');
    if (!piste || piste.dataset.aimancePret) return;
    piste.dataset.aimancePret = '1';
    var cartes = Array.prototype.slice.call(piste.children);
    var prec = racine.querySelector('[data-aimance-avis-prec]');
    var suiv = racine.querySelector('[data-aimance-avis-suiv]');
    var points = racine.querySelectorAll('[data-aimance-avis-points] > *');

    function pas() {
      if (cartes.length < 2) return piste.clientWidth;
      return cartes[1].offsetLeft - cartes[0].offsetLeft;
    }

    function maj() {
      var max = piste.scrollWidth - piste.clientWidth - 2;
      if (prec) prec.disabled = piste.scrollLeft <= 2;
      if (suiv) suiv.disabled = piste.scrollLeft >= max;
      var actif = Math.round(piste.scrollLeft / (pas() || 1));
      if (piste.scrollLeft >= max) actif = cartes.length - 1;
      points.forEach(function (p, i) {
        p.classList.toggle('is-actif', i === actif);
      });
      var deborde = piste.scrollWidth > piste.clientWidth + 2;
      if (prec) prec.parentElement.hidden = !deborde;
      points.length && (points[0].parentElement.hidden = !deborde);
    }

    if (prec)
      prec.addEventListener('click', function () {
        piste.scrollBy({ left: -pas(), behavior: 'smooth' });
      });
    if (suiv)
      suiv.addEventListener('click', function () {
        piste.scrollBy({ left: pas(), behavior: 'smooth' });
      });
    piste.addEventListener('scroll', function () {
      window.requestAnimationFrame(maj);
    });
    window.addEventListener('resize', maj);
    maj();
  }

  function initTousAvis() {
    document.querySelectorAll('[data-aimance-avis]').forEach(initAvis);
  }

  initTousAvis();
  document.addEventListener('shopify:section:load', initTousAvis);
  document.addEventListener('shopify:block:select', function (e) {
    var carte = e.target && e.target.closest && e.target.closest('.aimance-avis__carte');
    var piste = carte && carte.parentElement;
    if (piste) piste.scrollTo({ left: carte.offsetLeft - piste.offsetLeft, behavior: 'smooth' });
  });

  /* ------------------------------ Éditeur : ouvrir le tiroir quand on règle la section « Panier (tiroir) » */

  if (window.Shopify && window.Shopify.designMode) {
    var basculerTiroir = function (evenement, ouvrir) {
      if (!evenement.detail || evenement.detail.sectionId !== 'cart-drawer') return;
      var panier = document.querySelector('cart-drawer');
      if (!panier) return;
      if (ouvrir && typeof panier.open === 'function' && !panier.classList.contains('active')) panier.open();
      if (!ouvrir && typeof panier.close === 'function') panier.close();
    };
    document.addEventListener('shopify:section:select', function (e) {
      basculerTiroir(e, true);
    });
    document.addEventListener('shopify:block:select', function (e) {
      basculerTiroir(e, true);
    });
    document.addEventListener('shopify:section:load', function (e) {
      basculerTiroir(e, true);
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      basculerTiroir(e, false);
    });
  }
})();
